import { render } from "./HeroBanner.vue?vue&type=template&id=177ae090&scoped=true"
import script from "./HeroBanner.vue?vue&type=script&lang=js"
export * from "./HeroBanner.vue?vue&type=script&lang=js"

import "./HeroBanner.vue?vue&type=style&index=0&id=177ae090&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177ae090"]])

export default __exports__